var map = {
	"./arrows/dots.svg": 97615,
	"./arrows/down.svg": 36771,
	"./close.svg": 5074,
	"./del.svg": 8353,
	"./download.svg": 94710,
	"./edit.svg": 866,
	"./mail.svg": 72483,
	"./nav/azs.svg": 28660,
	"./nav/car.svg": 58982,
	"./nav/card.svg": 62630,
	"./nav/control.svg": 29155,
	"./nav/corp.svg": 7340,
	"./nav/credit-card.svg": 44614,
	"./nav/departments.svg": 49937,
	"./nav/edit.svg": 69808,
	"./nav/gas-station.svg": 64152,
	"./nav/info-circle.svg": 98901,
	"./nav/info.svg": 8680,
	"./nav/integration.svg": 36978,
	"./nav/map-point.svg": 77435,
	"./nav/monitoring.svg": 4850,
	"./nav/orders.svg": 61639,
	"./nav/reports.svg": 93581,
	"./nav/settings.svg": 13267,
	"./nav/stat.svg": 36402,
	"./nav/statements.svg": 31426,
	"./nav/users.svg": 95276,
	"./panic.svg": 65395,
	"./plus.svg": 39210,
	"./sb.svg": 17721,
	"./sber.svg": 63064,
	"./search.svg": 53182
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46669;